// Breakpoints following Bootstrap measures:
// https://getbootstrap.com/docs/5.0/layout/breakpoints/
const breakpointSm = 576
const breakpointMd = 768
const breakpointLg = 992
const breakpointXl = 1200
const breakpoint2xl = 1400

export const tabletBreakpoint = breakpointSm
export const desktopBreakpoint = breakpointLg
